import React from "react";
import {
    Navigate,
} from "react-router-dom";


const ExpensesListComponent = React.lazy(() => import("../../../../../components/stk-expenses/components/list/page"));
const ExpensesAddComponent = React.lazy(() => import("../../../../../components/stk-expenses/components/add/page"));

export const expenseRoutes = [
   
    {
        path: 'add',
        element: <ExpensesAddComponent />
    },
    {
        path: 'edit',
        element: <Navigate to="/finanzas/expenses/add" />
    },
    {
        path: 'edit/:id',
        element: <ExpensesAddComponent />
    },
     {
        path: 'list',
        element: <ExpensesListComponent />
    },
    {
        path: '',
        element: <Navigate replace to="/finanzas/expenses/list" />
    },
];

